export default __webpack_public_path__ + "static/media/quarto6.f016860b.jpg";